import { render } from "./ModalAlertDefault.vue?vue&type=template&id=04c92318&scoped=true"
import script from "./ModalAlertDefault.vue?vue&type=script&lang=js"
export * from "./ModalAlertDefault.vue?vue&type=script&lang=js"

import "./ModalAlertDefault.vue?vue&type=style&index=0&id=04c92318&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c92318"]])

export default __exports__